interface ProjectIntroProps {
	headline: string
	sectors?: any
	deliverables?: any
}

export default function ProjectIntro({headline, sectors, deliverables}:ProjectIntroProps) {
	return (
		<div className={`w-full px-site-margin sm:grid grid-cols-2 sm:grid-cols-12 gap-gutter mt-[3rem] mb-[6rem] md:mb-[10rem]`}>
			<div className="col-span-full md:col-span-8 lg:col-span-9 md:pr-1/5 mb-[4rem] sm:mb-[3rem] md:mb-0">
				<h2 className="style-h2 text-balance">{headline}</h2>
			</div>

			<div className="col-span-full md:col-span-4 lg:col-span-3 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-2 gap-gutter md:pt-3">
				{sectors?.length > 0 && (
					<div className="col-span-full mb-8 sm:col-span-1 sm:mb-0">
						<p className="style-h3 mb-4">{sectors?.length > 1 ? 'Sectors' : 'Sector'}</p>
						<ul className="style-body">
							{sectors?.map((sector, index) => <li key={`sector-${index}`}>{sector?.title}</li>)}
						</ul>
					</div>
				)}
				{deliverables && (
					<div className="col-span-full sm:col-span-3 md:col-span-1">
						<p className="style-h3 mb-4">{deliverables?.split('\n')?.length > 1 ? 'Deliverables' : 'Deliverable'}</p>
						<ul className="style-body">
							{deliverables
								?.split('\n')
								?.map((deliverable, index) => <li key={`deliverable-${index}`}>{deliverable}</li>)}
						</ul>
					</div>
				)}
			</div>
		</div>
	)
}